import type { LegalDocument } from '../types'
import { legalConsentInputName } from '../lib/legalConsent'
import { useI18n } from '../i18n/useI18n'

interface CentralLegalChecklistProps {
  title: string
  documents: LegalDocument[]
}

export function CentralLegalChecklist({ title, documents }: CentralLegalChecklistProps) {
  const { t } = useI18n()
  return (
    <fieldset className="central-legal-checklist">
      <legend>{title}</legend>
      {documents.map((document) => (
        <div className="central-legal-item" key={`${document.serviceCode}:${document.consentCode}:${document.documentVersion}`}>
          <label className="check-line">
            <input
              type="checkbox"
              name={legalConsentInputName(document)}
              required={document.requiredForService}
            />
            <span>
              {document.displayName}
              {document.requiredForService && <strong className="legal-required"> {t('legal.required')}</strong>}
              <small className="legal-version"> v{document.documentVersion}</small>
            </span>
          </label>
          <details className="central-legal-content">
            <summary>{t('legal.viewContent')}</summary>
            <pre>{document.content}</pre>
          </details>
        </div>
      ))}
    </fieldset>
  )
}
